import mainNationality from "./../../assets/locales/en/main.nationality.json";
import mainInterim from "./../../assets/locales/fr/main.interim.json";

export const en = { mainNationality, mainInterim };
